export const Phase = {
  SKETCH: 1,
  PRE: 2,
  MAIN: 3,
  WORK: 4,
  RESEARCH: 5,
}